const BASE_PATH = "app/admin/errors/";

export const SET_ERROR = `${BASE_PATH}set-errors`;
